export default "__VITE_ASSET__be9b4026__"